var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "sms_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sms_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 10.875c.25 0 .458-.083.625-.25a.848.848 0 00.25-.625.848.848 0 00-.25-.625.848.848 0 00-.625-.25.848.848 0 00-.625.25.848.848 0 00-.25.625c0 .25.083.458.25.625.167.167.375.25.625.25zm4 0c.25 0 .458-.083.625-.25a.848.848 0 00.25-.625.848.848 0 00-.25-.625.848.848 0 00-.625-.25.848.848 0 00-.625.25.848.848 0 00-.25.625c0 .25.083.458.25.625.167.167.375.25.625.25zm4 0c.25 0 .458-.083.625-.25a.848.848 0 00.25-.625.848.848 0 00-.25-.625.848.848 0 00-.625-.25.848.848 0 00-.625.25.848.848 0 00-.25.625c0 .25.083.458.25.625.167.167.375.25.625.25zM2.5 18.85V4.3c0-.5.175-.925.525-1.275.35-.35.775-.525 1.275-.525h15.4c.5 0 .925.175 1.275.525.35.35.525.775.525 1.275v11.4c0 .5-.175.925-.525 1.275-.35.35-.775.525-1.275.525H6.05l-2.025 2c-.283.283-.608.346-.975.188-.367-.159-.55-.438-.55-.838zM4 17.425L5.425 16H19.7a.29.29 0 00.213-.088A.289.289 0 0020 15.7V4.3a.292.292 0 00-.087-.213A.292.292 0 0019.7 4H4.3a.289.289 0 00-.212.087A.29.29 0 004 4.3v13.125zM4 4.3V4v13.425V4.3z",
    fill: "#12385C"
  }))));
}
export default SvgSms;